import axios from 'axios'
const API_URL = process.env.REACT_APP_BASEURL;
const Login_url = process.env.REACT_APP_LOGINURL;

const API = axios.create({ baseURL: Login_url});
export const logIn= (formData)=> API.post("login/" , formData);

export const getCurrentSessionUser = (sessionID, userId) => {
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(
    API_URL,
    {
      functionName: "GetUsers",
      postData: { _id: userId },
    },
    { headers }
  );
};

export const getRoleDetails = (sessionID, roleId) => {
  const headers = {
    "Content-Type": "application/json",
    token: sessionID,
  };
  return axios.post(
    API_URL,
    {
      functionName: "GetUserRole",
      postData: { _id: roleId },
    },
    { headers }
  );
};